import './cmslink.less'

import {m} from '@codeurs/front'
import {FunctionComponent} from 'react'
import {style} from 'util/style'

const styles = style('cmslink')

export const CmsLink: FunctionComponent<{
	entry: number
	project?: string
	lang?: string
}> = ({entry, project = 'klimaat', lang = 'nl'}) => {
	if (!entry || !window['__CMS_USER__']) return
	return (
		<a
			href={`/admin/project/${project}/${lang}/entry/${entry}`}
			target="_blank"
			class={styles}
		>
			Edit
		</a>
	)
}
